import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export function NavBar({ items = [], onBack }) {
  const navigate = useNavigate();
  return (
    <div className="nav-breadcrumb" data-testid="nav-breadcrumb">
      {onBack && (
        <button
          data-testid="nav-back-button"
          onClick={onBack}
          className="btn-arcade btn-surface"
          style={{ minHeight: 48, padding: '0 1rem', fontSize: '1.25rem', borderBottomWidth: 4 }}
        >
          <ChevronLeft size={24} />
        </button>
      )}
      {items.map((item, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span style={{ color: 'var(--text-muted)', fontSize: '1.5rem' }}>/</span>}
          <span
            style={{
              color: i === items.length - 1 ? 'var(--primary)' : 'var(--text-secondary)',
              fontSize: '1.4rem',
              fontWeight: i === items.length - 1 ? 700 : 500,
              fontFamily: 'Fredoka, sans-serif',
            }}
          >
            {item}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
